module.exports = __webpack_public_path__ + "static/media/coupon.d9aa6c65.png";